import React from 'react'
import {styles} from '../patient/styles/PatientPage.style'
import {i18n} from '../../i18n'
import {TitleText} from '../common'

const Impressum: React.FC = () => {
    return (
        <div style={styles.pageWrapper}>
            <TitleText text={i18n.t('impressum.title')}></TitleText>

            <p/>

            <h3>{i18n.t('impressum.company.name')}</h3>
            <p>
                {i18n.t('impressum.company.street')}<br />
                {i18n.t('impressum.company.postalCode')}<br /><br />
                {i18n.t('impressum.company.actorid')}
            </p>

            <p/>

            <h3>{i18n.t('impressum.ceo.header')}</h3>
            <p>
                {i18n.t('impressum.ceo.name')}<br />
                {i18n.t('impressum.contact.phoneLabel')}
                <a onClick={() => (window.location.href = 'tel:' + i18n.t('impressum.contact.phone'))} target='_blank'>
                    {i18n.t('impressum.contact.phone')}
                </a><br />
                {i18n.t('impressum.contact.emailLabel')}
                <a onClick={() => (window.location.href = 'mailto:' + i18n.t('impressum.contact.email'))} target='_blank'>
                    {i18n.t('impressum.contact.email')}
                </a>
            </p>

            <p/>

            <h3>{i18n.t('impressum.register.header')}</h3>
            <p>
                {i18n.t('impressum.register.vatId')}<br />
                {i18n.t('impressum.register.taxNr')}<br />
                {i18n.t('impressum.register.hrb')}<br />
                {i18n.t('impressum.register.court')}
            </p>
            
            <p/>

            <h3>{i18n.t('impressum.dataProtection.header')}</h3>
            <p>
                {i18n.t('impressum.dataProtection.name')}<br />
                {i18n.t('impressum.dataProtection.phoneLabel')}
                <a onClick={() => (window.location.href = 'tel:' + i18n.t('impressum.dataProtection.phone'))} target='_blank'>
                    {i18n.t('impressum.dataProtection.phone')}
                </a><br />
                {i18n.t('impressum.dataProtection.emailLabel')}
                <a onClick={() => (window.location.href = 'mailto:' + i18n.t('impressum.dataProtection.email'))} target='_blank'>
                    {i18n.t('impressum.dataProtection.email')}
                </a><br />
            </p>
        </div>
    )
}

export default Impressum
